/*
 * Shared search query enhancement for Gist Yarn.
 * Strips stop words, expands with weaving-specific synonyms.
 * Used by both the predictive search (header) and resource search widget.
 *
 * Usage: window.GistSearch.enhance("which loom should I buy")
 *        → "loom buy choose choosing"
 */
(function() {
  'use strict';

  var STOP_WORDS = [
    'a', 'an', 'the', 'i', 'me', 'my', 'we', 'our', 'you', 'your',
    'is', 'are', 'was', 'were', 'be', 'been', 'am',
    'do', 'does', 'did', 'doing',
    'have', 'has', 'had', 'having',
    'will', 'would', 'shall', 'should', 'can', 'could', 'may', 'might', 'must',
    'which', 'what', 'where', 'when', 'who', 'whom', 'how', 'why',
    'if', 'then', 'than', 'that', 'this', 'these', 'those',
    'and', 'or', 'but', 'not', 'no', 'nor', 'so', 'yet',
    'to', 'of', 'in', 'on', 'at', 'for', 'with', 'from', 'by', 'about',
    'it', 'its', 'some', 'any', 'all', 'both', 'each', 'every',
    'just', 'also', 'very', 'really', 'too', 'most', 'more',
    'need', 'want', 'get', 'got', 'go', 'going',
    'best', 'good', 'right', 'new'
  ];

  var SYNONYMS = {
    'buy': ['choose', 'choosing'],
    'purchase': ['choose', 'choosing'],
    'pick': ['choose', 'choosing'],
    'select': ['choose', 'choosing'],
    'selecting': ['choose', 'choosing'],
    'picking': ['choose', 'choosing'],
    'buying': ['choose', 'choosing'],
    'start': ['beginner', 'getting started', 'introduction'],
    'starting': ['beginner', 'getting started', 'introduction'],
    'begin': ['beginner', 'getting started', 'introduction'],
    'beginning': ['beginner', 'getting started', 'introduction'],
    'beginner': ['getting started', 'introduction'],
    'learn': ['how to', 'introduction', 'guide'],
    'learning': ['how to', 'introduction', 'guide'],
    'teach': ['how to', 'tutorial', 'guide'],
    'broken': ['fix', 'repair', 'broken'],
    'break': ['fix', 'broken'],
    'broke': ['fix', 'broken'],
    'repair': ['fix', 'repair'],
    'problem': ['fix', 'troubleshoot'],
    'problems': ['fix', 'troubleshoot'],
    'issue': ['fix', 'troubleshoot'],
    'issues': ['fix', 'troubleshoot'],
    'wrong': ['fix', 'troubleshoot'],
    'mistake': ['fix', 'troubleshoot'],
    'help': ['how to', 'tips', 'guide'],
    'amount': ['calculate', 'how much'],
    'quantity': ['calculate', 'how much'],
    'enough': ['calculate', 'how much'],
    'size': ['yarn sizes', 'sett', 'calculate'],
    'sizes': ['yarn sizes', 'sett'],
    'thick': ['yarn sizes', 'weight', 'wpi'],
    'thin': ['yarn sizes', 'weight', 'wpi'],
    'weight': ['yarn sizes', 'wpi'],
    'type': ['choose', 'fiber'],
    'types': ['choose', 'fiber'],
    'kind': ['choose', 'fiber'],
    'kinds': ['choose', 'fiber'],
    'finish': ['wet finish', 'finishing', 'hemstitch'],
    'finishing': ['wet finish', 'finishing', 'hemstitch', 'fringe'],
    'done': ['finishing', 'wet finish'],
    'edge': ['hemstitch', 'fringe', 'hem', 'selvedge'],
    'edges': ['hemstitch', 'fringe', 'hem', 'selvedge'],
    'border': ['hemstitch', 'fringe', 'hem'],
    'end': ['fringe', 'hemstitch', 'finishing'],
    'ends': ['fringe', 'hemstitch', 'finishing'],
    'wash': ['wet finish'],
    'washing': ['wet finish'],
    'clean': ['wet finish', 'care'],
    'convert': ['convert', 'adapt'],
    'adapt': ['convert', 'substitute'],
    'change': ['substitute', 'convert'],
    'replace': ['substitute'],
    'swap': ['substitute'],
    'switch': ['substitute', 'convert'],
    'substitute': ['substitute yarn'],
    'math': ['calculate', 'calculator'],
    'measure': ['calculate', 'wpi', 'sett'],
    'shrink': ['shrinkage', 'take-up'],
    'shrinkage': ['shrinkage', 'take-up'],
    'shrinking': ['shrinkage', 'take-up'],
    'tight': ['tension'],
    'loose': ['tension'],
    'uneven': ['tension'],
    'slack': ['tension'],
    'pattern': ['pattern', 'draft'],
    'patterns': ['pattern', 'draft'],
    'read': ['read', 'draft'],
    'draft': ['draft', 'pattern'],
    'drafts': ['draft', 'pattern'],
    'rigid': ['rigid heddle'],
    'heddle': ['rigid heddle'],
    'shaft': ['4-shaft', 'multi-shaft'],
    'floor': ['floor loom', 'multi-shaft'],
    'table': ['table loom'],
    'cotton': ['cotton', 'beam', 'mallo', 'duet'],
    'linen': ['linen', 'duet'],
    'wool': ['wool', 'array', 'dwella'],
    'silk': ['silk', 'sero'],
    'alpaca': ['alpaca', 'ode'],
    'rug': ['rug', 'dwella'],
    'tapestry': ['tapestry', 'array'],
    'mezoff': ['rebecca mezoff'],
    'rebecca': ['rebecca mezoff'],
    'subscription': ['weave quarterly', 'subscription box'],
    'quarterly': ['weave quarterly', 'subscription']
  };

  var stopSet = {};
  STOP_WORDS.forEach(function(w) { stopSet[w] = true; });

  function extractKeywords(term) {
    var words = term.toLowerCase().replace(/[^a-z0-9\s'/.-]/g, '').split(/\s+/);
    return words.filter(function(w) { return w.length > 1 && !stopSet[w]; });
  }

  function expandWithSynonyms(keywords) {
    var expanded = [];
    keywords.forEach(function(word) {
      expanded.push(word);
      if (SYNONYMS[word]) {
        SYNONYMS[word].forEach(function(syn) {
          if (expanded.indexOf(syn) === -1) expanded.push(syn);
        });
      }
    });
    return expanded;
  }

  /**
   * Enhance a search query by stripping stop words and adding synonyms.
   * Returns the enhanced query string.
   * If the input is short (1-2 words with no stop words), returns it unchanged
   * to avoid over-expanding simple product searches like "beam" or "duet yarn".
   */
  function enhance(term) {
    var trimmed = term.trim();
    if (!trimmed) return trimmed;

    var keywords = extractKeywords(trimmed);

    // If no keywords survived stop-word removal, return original
    if (keywords.length === 0) return trimmed;

    // For short, clean queries (no stop words stripped), don't expand —
    // these are likely intentional product/topic searches
    var originalWords = trimmed.toLowerCase().replace(/[^a-z0-9\s'/.-]/g, '').split(/\s+/).filter(function(w) { return w.length > 1; });
    if (originalWords.length <= 2 && originalWords.length === keywords.length) {
      return trimmed;
    }

    // Expand with synonyms
    var expanded = expandWithSynonyms(keywords);
    return expanded.join(' ');
  }

  window.GistSearch = {
    enhance: enhance,
    extractKeywords: extractKeywords,
    expandWithSynonyms: expandWithSynonyms,
    SYNONYMS: SYNONYMS
  };
})();
